export default {
  getTransactionPlayBook: (state) => state.transactionPlayBook,
};
